const isError = ref(false);

export const useChunkError = () => {
  return isError;
};
